import React from 'react';
import { motion } from 'framer-motion';
import { Lightbulb, BookOpen, AlertCircle } from 'lucide-react';
interface RuleCardProps {
  title: string;
  content: string;
  icon?: 'lightbulb' | 'book' | 'alert';
  label?: string;
  mode?: 'stimulus' | 'support';
}
export function RuleCard({
  title,
  content,
  icon = 'lightbulb',
  label,
  mode = 'support'
}: RuleCardProps) {
  const Icon = icon === 'lightbulb' ? Lightbulb : icon === 'book' ? BookOpen : AlertCircle;
  const isStimulus = mode === 'stimulus';
  return <motion.div initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1]
  }} className={`bg-amber-50 rounded-xl border border-amber-100 ${isStimulus ? 'p-3.5' : 'p-4'}`} data-id="element-9490">
      <div className="flex items-start gap-3" data-id="element-9491">
        <div className={`rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0 ${isStimulus ? 'w-8 h-8' : 'w-10 h-10'}`} data-id="element-9492">
          <Icon className={`text-amber-700 ${isStimulus ? 'w-4 h-4' : 'w-5 h-5'}`} data-id="element-9493" />
        </div>
        <div className="flex-1" data-id="element-9494">
          <h4 className={`font-bold text-amber-900 mb-1.5 ${isStimulus ? 'text-sm' : 'text-base'}`} data-id="element-9495">
            {label || title}
          </h4>
          <p className={`text-slate-700 leading-relaxed whitespace-pre-line ${isStimulus ? 'text-xs' : 'text-sm'}`} data-id="element-9496">
            {content}
          </p>
        </div>
      </div>
    </motion.div>;
}